import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/puesto/importer/puestoImporterActions';

export default importerReducers(actions);
